(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = window.matchMedia('(max-width: 900px)');

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function flashGuide(el, text) {
    if (!el) return;
    if (text) el.textContent = text;
    el.classList.remove('mp-guide-flash');
    void el.offsetWidth;
    el.classList.add('mp-guide-flash');
    setTimeout(() => el.classList.remove('mp-guide-flash'), 560);
  }

  function setMascotLead(root, lead) {
    if (!root) return;
    root.classList.remove('mp-mascot-lead-male','mp-mascot-lead-female');
    if (lead === 'male') root.classList.add('mp-mascot-lead-male');
    if (lead === 'female') root.classList.add('mp-mascot-lead-female');
  }

  function initScrollDepth() {
    if (!mobile.matches || reduced) return;
    const roots = [
      document.querySelector('.mpx-home'),
      document.querySelector('.mpx-product')
    ].filter(Boolean);
    if (!roots.length) return;

    const configs = [
      ['.blob,.shape', 12],
      ['.prod:nth-of-type(1),.hero-img', 22],
      ['.prod:nth-of-type(2),.state', -16],
      ['.prod:nth-of-type(3),.stamp', 30],
      ['.spark,.emoji', -24]
    ];

    const layers = roots.map((root) => ({
      anchor: root.querySelector('.hero,.top') || root,
      items: configs.flatMap(([selector, depth]) => [...root.querySelectorAll(selector)].map((el) => ({ el, depth })))
    }));
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight || 1;
      layers.forEach(({anchor, items}) => {
        const rect = anchor.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const center = rect.top + rect.height / 2;
        const progress = clamp((vh / 2 - center) / vh, -1.2, 1.2);
        items.forEach(({el, depth}) => {
          el.style.translate = '0 ' + (progress * depth).toFixed(2) + 'px';
        });
      });
    };
    const request = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    addEventListener('scroll', request, { passive: true });
    addEventListener('resize', request, { passive: true });
    update();
  }

  function initTouchFeedback() {
    const selector = [
      '.mood-card','.prod','.btn','.card','.buy',
      '.mp-diagnosis__choices button','.card-wrapper','.collection-list .card-wrapper'
    ].join(',');
    document.querySelectorAll(selector).forEach((el) => {
      el.classList.add('mp-touchable');
      el.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mp-touch-x', (event.clientX - rect.left) + 'px');
        el.style.setProperty('--mp-touch-y', (event.clientY - rect.top) + 'px');
        el.classList.add('mp-touching');
      }, { passive: true });
      ['pointerup','pointercancel','pointerleave'].forEach((name) => {
        el.addEventListener(name, () => setTimeout(() => el.classList.remove('mp-touching'), 120), { passive: true });
      });
    });
  }

  function initSwipeMood() {
    const row = document.querySelector('.mpx-home .mood-grid');
    if (!row || !mobile.matches) return;
    const cards = [...row.querySelectorAll('.mood-card')];
    if (cards.length < 2) return;

    const dots = document.createElement('div');
    dots.className = 'mp-swipe-dots';
    cards.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', (index + 1) + '番目の気分');
      if (index === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => cards[index].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }));
      dots.appendChild(dot);
    });
    row.after(dots);

    let ticking = false;
    row.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const center = row.scrollLeft + row.clientWidth / 2;
        let best = 0, distance = Infinity;
        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const d = Math.abs(cardCenter - center);
          if (d < distance) { distance = d; best = index; }
        });
        [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === best));
      });
    }, { passive: true });
  }

  function initSeasonalGuide() {
    const root = document.querySelector('[data-mp-seasonal]');
    if (!root) return;
    const title = root.querySelector('[data-mp-seasonal-title]');
    const text = root.querySelector('[data-mp-seasonal-text]');
    const link = root.querySelector('[data-mp-seasonal-link]');
    const month = new Date().getMonth() + 1;
    let season;
    if (month === 12 || month <= 2) {
      season = { cls:'is-winter', title:'冬は、みんなで鍋にしよう。 🍲', text:'もつ鍋・水炊きで、あったかい食卓を。', href:'/collections/motsunabe-mizutaki', lead:'male' };
    } else if (month <= 5) {
      season = { cls:'is-spring', title:'春のごちそう、見つけよう。 🌸', text:'贈り物にも、集まりにも。気分に合う一品を。', href:'/collections/meat-gift', lead:'female' };
    } else if (month <= 8) {
      season = { cls:'is-summer', title:'夏の食卓、もっと軽やかに。 ☀️', text:'海鮮やさっぱり系も含めて、夏の気分で選ぼう。', href:'/collections/seafood', lead:'female' };
    } else {
      season = { cls:'is-autumn', title:'食欲の秋、何にする？ 🍁', text:'焼肉・ステーキからごほうびグルメまで、選ぶ時間も楽しもう。', href:'/collections/yakiniku-steak', lead:'male' };
    }
    root.classList.add(season.cls);
    title.textContent = season.title;
    text.textContent = season.text;
    link.href = season.href;
    setMascotLead(root, season.lead);
  }

  function initDiagnosis() {
    const root = document.querySelector('[data-mp-diagnosis]');
    if (!root) return;
    const step1 = root.querySelector('[data-mp-step="1"]');
    const step2 = root.querySelector('[data-mp-step="2"]');
    const result = root.querySelector('[data-mp-result]');
    const title = root.querySelector('[data-mp-result-title]');
    const link = root.querySelector('[data-mp-result-link]');
    let mood = '';
    const status = root.querySelector('[data-mp-diagnosis-status]');

    const map = {
      gift: { title: '贈り物から選ぶ', href: '/collections/meat-gift' },
      'hearty:grill': { title: '焼肉・ステーキ', href: '/collections/yakiniku-steak' },
      'hearty:nabe': { title: 'もつ鍋・水炊き', href: '/collections/motsunabe-mizutaki' },
      'hearty:easy': { title: '惣菜・加工品', href: '/collections/prepared-foods' },
      'group:grill': { title: '焼肉・ステーキ', href: '/collections/yakiniku-steak' },
      'group:nabe': { title: 'みんなで、もつ鍋・水炊き', href: '/collections/motsunabe-mizutaki' },
      'group:easy': { title: '惣菜・加工品', href: '/collections/prepared-foods' },
      'variety:grill': { title: '牛肉・和牛から探す', href: '/collections/beef-wagyu' },
      'variety:nabe': { title: 'もつ鍋・水炊き', href: '/collections/motsunabe-mizutaki' },
      'variety:easy': { title: '気軽に選べる惣菜・加工品', href: '/collections/prepared-foods' }
    };

    root.querySelectorAll('[data-mp-mood]').forEach((button) => {
      button.addEventListener('click', () => {
        mood = button.dataset.mpMood;
        if (status) status.textContent = mood === 'gift' ? '贈り物を探すなら、こちら！' : '次は、楽しみ方を選んでね。';
        root.querySelectorAll('[data-mp-mood]').forEach((b) => b.classList.toggle('is-selected', b === button));
        if (mood === 'gift') {
          const target = map.gift;
          title.textContent = target.title;
          link.href = target.href;
          step2.hidden = true;
          result.hidden = false;
          flashGuide(document.querySelector('[data-mp-home-bubble]'), '贈り物ならここ！いいの見つけよう 🎁');
          setMascotLead(root, 'female');
          result.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        } else {
          step2.hidden = false;
          step2.classList.add('is-active');
          result.hidden = true;
          step2.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        }
      });
    });

    root.querySelectorAll('[data-mp-scene]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-mp-scene]').forEach((b) => b.classList.toggle('is-selected', b === button));
        const target = map[mood + ':' + button.dataset.mpScene] || { title: '商品一覧', href: '/collections/all' };
        title.textContent = target.title;
        link.href = target.href;
        if (status) status.textContent = target.title + 'から探してみよう！';
        result.hidden = false;
        const guide = document.querySelector('[data-mp-home-bubble]');
        const messages = {
          '焼肉・ステーキ':'ガツンといくならこれ！ 🔥',
          'もつ鍋・水炊き':'みんなで囲むならこれ！ 🍲',
          'みんなで、もつ鍋・水炊き':'みんなで囲むならこれ！ 🍲',
          '惣菜・加工品':'手軽に楽しむならここ！ ⚡',
          '牛肉・和牛から探す':'まずは牛肉・和牛から見よう！ 🥩',
          '気軽に選べる惣菜・加工品':'気軽に選ぶならここ！ ✨'
        };
        flashGuide(guide, messages[target.title] || (target.title + 'を見てみよう！'));
        setMascotLead(root, /贈|惣菜|気軽/.test(target.title) ? 'female' : 'male');
        result.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      });
    });

    root.querySelector('[data-mp-reset]')?.addEventListener('click', () => {
      mood = '';
      if (status) status.textContent = 'まずは、今の気分から選んでね。';
      root.querySelectorAll('.is-selected').forEach((el) => el.classList.remove('is-selected'));
      step2.hidden = true;
      result.hidden = true;
      setMascotLead(root, '');
      flashGuide(document.querySelector('[data-mp-home-bubble]'), '今日は何にする？一緒に探そう！ 😋');
      step1.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
    });
  }

  function initProductNavigator() {
    const root = document.querySelector('.mpx-product');
    if (!root) return;
    const available = root.dataset.mpProductAvailable === 'true';
    const variants = Number(root.dataset.mpProductVariants || 1);
    const bubble = root.querySelector('[data-mp-product-bubble]');
    const mascotZone = root.querySelector('.mp-product-mascots');

    if (available) {
      flashGuide(bubble, variants > 1 ? '選べる種類があるよ！比べてみよう 👀' : '今なら選べるよ！商品情報をチェック 👀');
      setMascotLead(mascotZone, 'male');
    } else {
      flashGuide(bubble, '在庫準備中。中身を先に見ておこう ✨');
      setMascotLead(mascotZone, 'female');
    }
  }

  function initDynamicCta() {
    if (!mobile.matches) return;
    const home = document.querySelector('.mpx-home');
    const product = document.querySelector('.mpx-product');

    if (home) {
      const cta = document.createElement('a');
      cta.className = 'mp-dynamic-cta';
      cta.href = '/collections/all';
      cta.textContent = '🍽 商品を見てみる';
      document.body.appendChild(cta);

      const zones = [
        { el: home.querySelector('.hero'), label: '🍽 商品を見てみる', href: '/collections/all' },
        { el: home.querySelector('.mood'), label: '👉 気分から選ぶ', action: '.mood-grid' },
        { el: document.querySelector('[data-mp-diagnosis]'), label: '🎯 2タップ診断をする', action: '[data-mp-diagnosis]' },
        { el: document.querySelector('#shopify-section-template--') || document.querySelector('.collection-list'), label: '🛍 商品一覧へ', href: '/collections/all' }
      ].filter((z) => z.el);

      const set = (zone) => {
        cta.textContent = zone.label;
        if (zone.href) {
          cta.href = zone.href;
          cta.onclick = null;
        } else {
          cta.href = '#';
          cta.onclick = (e) => {
            e.preventDefault();
            document.querySelector(zone.action)?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
          };
        }
      };
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const zone = zones.find((z) => z.el === visible.target);
        if (zone) set(zone);
      }, { threshold: [0.25,0.5,0.75] });
      zones.forEach((z) => observer.observe(z.el));
      set(zones[0]);
      setTimeout(() => cta.classList.add('is-visible'), 500);
    }

    if (product) {
      const cta = product.querySelector('.float-buy') || document.createElement('button');
      if (!cta.isConnected) {
        cta.className = 'mp-dynamic-cta';
        document.body.appendChild(cta);
      } else {
        cta.classList.add('mp-dynamic-cta','is-visible');
      }

      const main = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product-form') || document.querySelector('[id^="MainProduct-"]');
      const available = product.dataset.mpProductAvailable === 'true';
      const backLabel = available ? '🛒 価格・内容へ戻る ↑' : '🟡 在庫準備中・商品情報へ ↑';
      const zones = [
        { el: product.querySelector('.top'), label: available ? '🛒 価格・内容を見る' : '🟡 在庫準備中・商品情報を見る' },
        { el: product.querySelector('.quick'), label: '🛒 価格・内容を見る' },
        { el: product.querySelector('.story'), label: backLabel },
        { el: product.querySelector('.buy-zone'), label: backLabel }
      ].filter((z) => z.el);
      cta.type = 'button';
      cta.onclick = () => main?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const zone = zones.find((z) => z.el === visible.target);
        if (zone) cta.textContent = zone.label;
      }, { threshold: [0.2,0.5,0.8] });
      zones.forEach((z) => observer.observe(z.el));
      cta.classList.add('is-visible');
    }
  }

  function initFixedDuo() {
    const root = document.querySelector('[data-mp-fixed-duo]');
    if (!root) return;
    const button = root.querySelector('.mp-fixed-duo__button');
    const menu = root.querySelector('.mp-fixed-duo__menu');
    const bubble = root.querySelector('[data-mp-fixed-duo-bubble]');
    if (!button || !menu) return;

    const path = location.pathname;
    if (bubble) {
      if (path.startsWith('/products/')) bubble.textContent = 'この商品、いっしょに見よう！';
      else if (path.startsWith('/collections/')) bubble.textContent = '気になるカテゴリ、見ていこう！';
      else if (path.includes('/faq')) bubble.textContent = '困ったらここで解決！';
      else if (path.includes('/meat-guide')) bubble.textContent = '迷ったら一緒に選ぼう！';
      else bubble.textContent = '何を探す？一緒に見よう！';
    }

    const react = () => {
      root.classList.remove('is-reacting');
      void root.offsetWidth;
      root.classList.add('is-reacting');
      setTimeout(() => root.classList.remove('is-reacting'), 620);
    };

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      react();
    });

    document.querySelectorAll('[data-mp-mood],[data-mp-scene],.mood-card,.card-wrapper').forEach((el) => {
      el.addEventListener('click', react, { passive: true });
    });
  }

  function initGlobalMascotGuide() {
    const root = document.querySelector('[data-mp-global-guide]');
    if (!root) return;
    const toggle = root.querySelector('.mp-global-guide__toggle');
    const panel = root.querySelector('.mp-global-guide__panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      if (!open) {
        root.querySelectorAll('.mp-site-mascot').forEach((mascot, index) => {
          setTimeout(() => {
            mascot.classList.remove('is-pop');
            void mascot.offsetWidth;
            mascot.classList.add('is-pop');
          }, index * 80);
        });
      }
    });
  }

  function initMascots() {
    const hero = document.querySelector('.mp-hero-mascots');
    if (hero && !reduced) {
      const images = [...hero.querySelectorAll('img')];
      Promise.all(images.map((image) => image.decode?.().catch(() => {}) || Promise.resolve())).then(() => {
        hero.classList.add('is-entering');
        setTimeout(() => hero.classList.remove('is-entering'), 850);
      });
    }
    document.querySelectorAll('.mp-site-mascot').forEach((mascot) => {
      let pointer = null;
      let pressed = false;
      let timer;
      const reset = () => mascot.classList.remove('is-pop','is-head-release','is-head-pressed');
      const release = (event) => {
        if (pointer !== event.pointerId) return;
        pointer = null;
        const rebound = pressed && event.type !== 'pointercancel';
        pressed = false;
        reset();
        if (rebound && !reduced) {
          mascot.classList.add('is-head-release');
          timer = setTimeout(reset, 350);
        }
      };
      mascot.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || pointer !== null || reduced) return;
        clearTimeout(timer);
        hero?.classList.remove('is-entering');
        reset();
        const rect = mascot.getBoundingClientRect();
        pointer = event.pointerId;
        pressed = (event.clientY - rect.top) / rect.height <= .36;
        mascot.setPointerCapture?.(event.pointerId);
        mascot.classList.add(pressed ? 'is-head-pressed' : 'is-pop');
        if (!pressed) timer = setTimeout(reset, 370);
      }, { passive:true });
      ['pointerup','pointercancel','lostpointercapture'].forEach((name) => mascot.addEventListener(name, release, { passive:true }));
    });
    const diagnosis = document.querySelector('[data-mp-diagnosis]');
    diagnosis?.querySelectorAll('[data-mp-mood],[data-mp-scene]').forEach((button) => {
      button.addEventListener('click', () => {
        const mascot = diagnosis.querySelector('.mp-site-mascot');
        if (!mascot || reduced) return;
        mascot.classList.remove('is-pop');
        requestAnimationFrame(() => mascot.classList.add('is-pop'));
        setTimeout(() => mascot.classList.remove('is-pop'), 370);
      });
    });
  }

  const init = () => {
    initScrollDepth();
    initTouchFeedback();
    initSwipeMood();
    initSeasonalGuide();
    initDiagnosis();
    initProductNavigator();
    initDynamicCta();
    initMascots();
    initGlobalMascotGuide();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
